import request from '@/utils/request'

//设备列表
export function getDevicePage(data) {
    return request({
        url: '/api/admin/config/getDevicePage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}

//设备列表
export function getProductDevicePage(data) {
    return request({
        url: '/api/admin/config/getProductDevicePage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}


//设备分组分页
export function getDeviceGroupPage(data) {
    return request({
        url: '/api/admin/config/getDeviceGroupPage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}

// 加载设备分组
export function loadDeviceGroups(data) {
    console.log("loadDeviceGroups--data", data)
    return request({
        url: '/api/admin/config/getAreaGroup',
        method: 'post',
        data
    })
}

// 保存分组信息
export function saveDeviceGroup(data) {
    return request({
        url: '/api/admin/config/saveDeviceGroup',
        method: 'post',
        data
    })
}

// 获取分组设备ID列表
export function getGroupDeviceIds(data) {
    return request({
        url: '/api/admin/config/getGroupDeviceIds',
        method: 'post',
        data
    })
}




// 获取设备统计
export function getDeviceStat(data) {
    return request({
        url: '/api/admin/config/getDeviceStat',
        method: 'post',
        data
    })
}

export function updDevicesDisable(data) {
    return request({
        url: '/api/admin/config/updDevicesDisable',
        method: 'post',
        data
    })
}


// 获取区域ID名称映射
export function getAreaMap() {
    return request({
        url: '/api/admin/commons/getAreaMap',
        method: 'post'
    })
}

// 获取区域ID名称映射
export function getDeviceDetail(data) {
    return request({
        url: '/api/admin/config/getDeviceData?t='+new Date().getTime(),
        method: 'post',
        data
    })
}

// 保存设备信息(重要信息已滤，禁止修改)
export function saveDeviceData(data) {
    return request({
        url: '/api/admin/config/saveDeviceData',
        method: 'post',
        data
    })
}

// 获取(蒲公英)版本列表
export function getPgyAppVersionList(data) {
    return request({
        url: '/api/admin/config/getAppVersionList',
        method: 'post',
        data
    })
}

// 获取(蒲公英)版本列表
export function getPtAppVersionList(data) {
    return request({
        url: '/api/admin/config/getPtAppVersionList',
        method: 'post',
        data
    })
}


// 设置版本更新
export function setUpgradeVersion(data) {
    return request({
        url: '/api/admin/config/setUpgradeVersion',
        method: 'post',
        data
    })
}

// 取消版本更新
export function setCancelUpgradeVersion(data) {
    return request({
        url: '/api/admin/config/setCancelUpgradeVersion',
        method: 'post',
        data
    })
}

// 保存批次信息
export function saveDeviceBatch(data) {
    return request({
        url: '/api/admin/config/saveDeviceBatch',
        method: 'post',
        data
    })
}

//设备批次列表
export function getDeviceBatchPage(data) {
    return request({
        url: '/api/admin/config/getDeviceBatchPage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}

//获取默认贴签信息
export function getDefaultLabel() {
    return request({
        url: '/api/admin/config/getDefaultLabel',
        method: 'post'
    })
}

// 保存默认贴签信息
export function saveDefaultLabel(data) {
    return request({
        url: '/api/admin/config/saveDefaultLabel',
        method: 'post',
        data
    })
}

// 保存默认贴签信息
export function saveDeviceLabel(data) {
    return request({
        url: '/api/admin/config/saveDeviceLabel',
        method: 'post',
        data
    })
}

export function resetDeviceLabel(data) {
    return request({
        url: '/api/admin/config/resetDeviceLabel',
        method: 'post',
        data
    })
}


// 保存批次的贴签信息
export function saveDeviceBatchLabel(data) {
    return request({
        url: '/api/admin/config/saveDeviceBatchLabel',
        method: 'post',
        data
    })
}


// 获取某批次的贴签信息
export function getBatchLabel(data) {
    return request({
        url: '/api/admin/config/getBatchLabel',
        method: 'post',
        data
    })
}

// 获取批次设备ID列表
export function getBatchDeviceIds(data) {
    return request({
        url: '/api/admin/config/getBatchDeviceIds',
        method: 'post',
        data
    })
}



// 获取更新进度
export function getCtrlTaskStep(data) {
    return request({
        url: '/api/admin/config/getCtrlTaskStep',
        method: 'post',
        data
    })
}

// 通知重启操作
export function setReboot(data) {
    return request({
        url: '/api/admin/config/setReboot',
        method: 'post',
        data
    })
}

// 获取当前登录账号的角色
export function getUserRoleType() {
    return request({
        url: '/api/admin/config/getUserRoleType',
        method: 'post'
    })
}

// 获取设备绑定状态
export function getDeviceBindState(data) {
    return request({
        url: '/api/admin/config/getDeviceBindState',
        method: 'post',
        data
    })
}

// 获取全部分组列表
export function getDeviceGrops() {
    return request({
        url: '/api/admin/config/getDeviceGrops',
        method: 'post'
    })
}

// 获取设备贴签信息
export function getDeviceLabel(data) {
    return request({
        url: '/api/admin/config/getDeviceLabel',
        method: 'post',
        data
    })
}

// 获取设备贴签信息
export function getDeviceLabels(data) {
    return request({
        url: '/api/admin/config/getDeviceLabels',
        method: 'post',
        data
    })
}

// 切换设备分组
export function resetDeviceGroup(data) {
    return request({
        url: '/api/admin/config/resetDeviceGroup',
        method: 'post',
        data
    })
}

// 保存设备分组
export function setDeviceGroup(data) {
    return request({
        url: '/api/admin/config/setDeviceGroup',
        method: 'post',
        data
    })
}

// 从分组移出设备
export function removeDeviceFromGroup(data) {
    return request({
        url: '/api/admin/config/removeDeviceFromGroup',
        method: 'post',
        data
    })
}


//设备运行日志列表
export function getDeviceELogPage(data) {
    return request({
        url: '/api/admin/config/getDeviceELogPage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}

// 保存版本信息
export function saveApkvn(data) {
    return request({
        url: '/api/admin/config/saveApkvn',
        method: 'post',
        data
    })
}

// 加载最后版本
export function getLastVn(data) {
    return request({
        url: '/api/admin/config/getLastVn',
        method: 'post',
        data
    })
}

/**
 * Apk上传
 * @param data
 */
export function uploadApkApi(data, params) {
    return request({
        url: '/api/admin/platform/upload/uploadApk',
        method: 'POST',
        params,
        data,
    });
}

export function uploadLoveHavenImg(data, params) {
    return request({
        url: '/api/admin/platform/upload/uploadLoveHavenImg',
        method: 'POST',
        params,
        data,
    });
}

/**
 * 保存音量配置
 * @param { deviceId,volume,tVolume } data
 * @param {*} params
 * @returns
 */
export function saveDeviceVolume(data, params) {
    return request({
        url: '/api/admin/config/saveDeviceVolume',
        method: 'POST',
        params,
        data,
    });
}

/**
 * 删除服务端缓存
 * @param { deviceId,volume,tVolume } data
 * @param {*} params
 * @returns
 */
export function removeRKey(data, params) {
    return request({
        url: '/api/admin/config/removeRKey',
        method: 'POST',
        params,
        data,
    });
}


/**
 * 保存控制时的验证密码
 * @param {*} data
 * @param {*} params
 * @returns
 */
export function saveCtrlPasswd(data, params) {
    return request({
        url: '/api/admin/config/saveCtrlPasswd',
        method: 'POST',
        params,
        data,
    });
}

export function saveBatchCtrlPasswd(data, params) {
    return request({
        url: '/api/admin/config/saveBatchCtrlPasswd',
        method: 'POST',
        params,
        data,
    });
}


// 设备开启/关闭掉线警报

export function setDeviceWarning(data) {
    return request({
        url: '/api/admin/config/setDeviceWarning',
        method: 'post',
        data
    })
}

// 批量设备开启/关闭掉线警报

export function setBatchDeviceWarning(data) {
    return request({
        url: '/api/admin/config/setBatchDeviceWarning',
        method: 'post',
        data
    })
}

//接线员列表
export function getSosServicePage(data) {
    return request({
        url: '/sos/getServicePage?page=' + data.page + "&limit=" + data.limit,
        method: 'post',
        data
    })
}

//接线员列表
export function saveService(data) {
    return request({
        url: '/sos/saveService',
        method: 'post',
        data
    })
}

//删除接线员
export function delService(data) {
    return request({
        url: '/sos/delService',
        method: 'post',
        data
    })
}

//更新接线员可用状态
export function updServiceUse(data) {
    return request({
        url: '/sos/updServiceUse',
        method: 'post',
        data
    })
}

//紧急呼叫日志查询
export function getSosLogPage(data) {
    return request({
        url: '/sos/getSosLogPage',
        method: 'post',
        data
    })
}

// 保存爱心港信息
export function saveLoves(data) {
    return request({
        url: '/api/admin/config/saveLoves',
        method: 'post',
        data
    })
}

// 按经纬度获取行政区划信息
// 参数：lng,lat
export function getAreaByGeo(data) {
    return request({
        url: '/api/admin/config/getAreaByGeo',
        method: 'post',
        data
    })
}

// 启动批量更新
export function startUpgradeTaskBatch(data) {
    return request({
        url: '/api/admin/config/startUpgradeTaskBatch',
        method: 'post',
        data
    })
}

// 获取批量更新任务执行情况
export function getUpgradeTaskPage(data) {
    return request({
        url: '/api/admin/config/getUpgradeTaskPage',
        method: 'post',
        data
    })
}

// 获取批量更新任务执行情况
export function checkUpgradeDevices(data) {
    return request({
        url: '/api/admin/config/checkUpgradeDevices',
        method: 'post',
        data
    })
}

// 获取批量更新任务执行情况
export function getUpgradeDevicesPage(data) {
    return request({
        url: '/api/admin/config/getUpgradeDevicesPage',
        method: 'post',
        data
    })
}

// 取消一个设备的更新任务
export function cannelDeviceUpgrade(data) {
    return request({
        url: '/api/admin/config/cannelDeviceUpgrade',
        method: 'post',
        data
    })
}


